import {
  FontColorEnum,
  FontSizeEnum,
  FontWeightEnum,
  IconSizeEnum,
  Typography,
} from '@acceso/design-system';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import { Clock } from '@/components/Clock';
import { HelpTour } from '@/components/HelpTour/HelpTour';
import { Shorcut } from '@/components/Shorcut/Shorcut';
import { useBroadcastScheduleProgram } from '@/features/broadcast-schedule-program/context/BroadcastScheduleProgramContext';

import { useSegmentsTour } from '../../hooks/use-segments-tour';

export function SegmentsHeaderName() {
  const { t } = useTranslation();
  const { isHeaderVisible } = useBroadcastScheduleProgram();
  const { startTour } = useSegmentsTour();

  return (
    <div
      className={clsx('flex flex-wrap items-center', isHeaderVisible && 'justify-between')}
      id="segments-name"
    >
      <Typography
        fontSize={FontSizeEnum.Xl}
        weight={FontWeightEnum.Bold}
        color={FontColorEnum.Dark10}
      >
        {t('Franjas')}
      </Typography>

      {isHeaderVisible && (
        <div className="flex items-center gap-2">
          <Clock fontSize={FontSizeEnum.Md} iconSize={IconSizeEnum.SM} />
          <Shorcut />
          <HelpTour tour={startTour} />
        </div>
      )}
    </div>
  );
}
